import {
  default as MuiFilledInput,
  type FilledInputProps as MuiFilledInputProps,
  filledInputClasses as muiFilledInputClasses,
} from '@mui/material/FilledInput';

/**
 * @deprecated Unsupported component: Use Input instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
export const FilledInput = MuiFilledInput;
/**
 * @deprecated Unsupported component: Use Input instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
export type FilledInputProps = MuiFilledInputProps;
/**
 * @deprecated Unsupported component: Use Input instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
export const filledInputClasses = muiFilledInputClasses;
